(() => {
  if (!customElements.get('ab-card-gallery')) customElements.define('ab-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); this.classList.toggle('is-alternate'); }));
    }
  });
  if (!customElements.get('ab-editorial-navigation')) {
    customElements.define('ab-editorial-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('.ab-mobile-localization select').forEach(select => select.addEventListener('change', () => select.form.requestSubmit(), options));
        const toggle = this.querySelector('.ab-menu-toggle');
        const triggers = [...this.querySelectorAll('.ab-navigation__trigger')];
        const closePanels = () => triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
        const close = () => { closePanels(); toggle.setAttribute('aria-expanded', 'false'); this.classList.remove('is-open'); document.documentElement.classList.remove('ab-menu-open'); };
        toggle.addEventListener('click', () => {
          const open = !this.classList.contains('is-open');
          close();
          if (open) { this.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('ab-menu-open'); }
        }, options);
        triggers.forEach(trigger => {
          trigger.addEventListener('click', () => {
            const open = matchMedia('(min-width:1025px) and (hover:hover)').matches || trigger.getAttribute('aria-expanded') !== 'true'; closePanels(); trigger.setAttribute('aria-expanded', String(open));
          }, options);
          const item = trigger.closest('.ab-navigation__item');
          item.addEventListener('mouseenter', () => { if (matchMedia('(min-width:1025px) and (hover:hover)').matches) { closePanels(); trigger.setAttribute('aria-expanded', 'true'); } }, options);
          item.addEventListener('mouseleave', () => { if (matchMedia('(min-width:1025px) and (hover:hover)').matches) trigger.setAttribute('aria-expanded', 'false'); }, options);
        });
        document.addEventListener('click', e => { if (!this.contains(e.target)) close(); }, options);
        document.addEventListener('keydown', e => { if (e.key === 'Escape' && (this.classList.contains('is-open') || triggers.some(t => t.getAttribute('aria-expanded') === 'true'))) { close(); toggle.offsetParent ? toggle.focus() : triggers[0].focus(); } }, options);
        this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget) && !this.classList.contains('is-open')) closePanels(); }, options);
      }
      disconnectedCallback() { this.controller?.abort(); this.ready = false; document.documentElement.classList.remove('ab-menu-open'); }
    });
  }
  // The filter controls stay available while the collection is in view.
  const mountToolbar = () => {
    const section = document.querySelector('.sec__collection-main');
    if (!section || section.dataset.abToolbarReady) return;
    section.dataset.abToolbarReady = 'true';
    const observer = new IntersectionObserver(entries => entries.forEach(entry => document.body.classList.toggle('ab-collection-in-view', entry.isIntersecting)), { threshold: 0 });
    observer.observe(section);
  };
  mountToolbar();
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-mci-open="sort"]')) return;
    document.querySelectorAll('[data-mci-sheet="sort"] [data-sort-value]').forEach(link => {
      const target = new URL(location.href);
      target.searchParams.set('sort_by', link.dataset.sortValue);
      target.searchParams.delete('page');
      link.href = target.pathname + target.search;
    });
  });
  document.addEventListener('shopify:section:load', mountToolbar);
  const stickyGalleries = new Map();
  const mountProductGalleries = () => {
    for (const [column, dispose] of stickyGalleries) {
      if (!column.isConnected) { dispose(); stickyGalleries.delete(column); }
    }
    document.querySelectorAll('[id^="MainProduct-"] .product-detail__media').forEach(column => {
      if (stickyGalleries.has(column) || !column.querySelector('[id^="GalleryViewer-"]')) return;
      const header = document.querySelector('.section-header');
      let frame;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!matchMedia('(min-width:1024px)').matches) {
            delete column.dataset.abStickyGallery;
            column.style.removeProperty('--ab-gallery-top');
            return;
          }
          const height = column.getBoundingClientRect().height;
          if (!height) return;
          const headerSpace = (header?.getBoundingClientRect().height || 54) + 16;
          const top = Math.min(headerSpace, window.innerHeight - height - 24);
          column.style.setProperty('--ab-gallery-top', `${Math.round(top * 100) / 100}px`);
          column.dataset.abStickyGallery = '';
        });
      };
      const observer = new ResizeObserver(update);
      observer.observe(column);
      if (header) observer.observe(header);
      window.addEventListener('resize', update, { passive:true });
      stickyGalleries.set(column, () => {
        observer.disconnect();
        cancelAnimationFrame(frame);
        window.removeEventListener('resize', update);
      });
      update();
    });
  };
  mountProductGalleries();
  document.addEventListener('shopify:section:load', mountProductGalleries);
  document.addEventListener('shopify:section:unload', event => {
    for (const [column, dispose] of stickyGalleries) {
      if (event.target.contains(column)) { dispose(); stickyGalleries.delete(column); }
    }
  });
})();
